import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const Contact = () => {
  return (
    <section style={styles.section} id='contact'>
      <h2 style={styles.title}>Contact Us</h2>
      <p style={styles.description}>
        Have any questions or need assistance? Feel free to reach out to us using the contact details below.
      </p>

      <div style={styles.contactContainer}>
        <div style={styles.contactItem}>
          <FaPhoneAlt style={styles.icon} />
          <h3 style={styles.contactTitle}>Phone</h3>
          <p style={styles.contactText}>+352 150 623 555</p>
        </div>

        <div style={styles.contactItem}>
          <FaEnvelope style={styles.icon} />
          <h3 style={styles.contactTitle}>Email</h3>
          <p style={styles.contactText}>info@bryzelo.com </p>
        </div>

        <div style={styles.contactItem}>
          <FaMapMarkerAlt style={styles.icon} />
          <h3 style={styles.contactTitle}>Address</h3>
          <p style={styles.contactText}>61 Rue Léon Hengen, Luxembourg</p>
        </div>

        <div style={styles.contactItem}>
          <FaClock style={styles.icon} />
          <h3 style={styles.contactTitle}>Working Hours</h3>
          <p style={styles.contactText}>Mon - Fri: 9:00 AM - 6:00 PM</p>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '100px 20px',
    textAlign: 'center',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  description: {
    fontSize: '1.2rem',
    maxWidth: '800px',
    margin: '0 auto 40px',
    lineHeight: '1.6',
  },
  contactContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
  },
  contactItem: {
    maxWidth: '300px',
    textAlign: 'center',
  },
  icon: {
    fontSize: '3rem',
    color: ' #0a6b88',
    marginBottom: '15px',
  },
  contactTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  contactText: {
    fontSize: '1rem',
    opacity: '0.8',
  },
};

export default Contact;
